import { useCallback } from 'react'
import { useCurrentOrg } from 'auth/hooks'
import useFetchRefactored from 'civic-champs-shared/api/hooks/useFetchRefactored'
import { Person } from 'people/interface'
import { Status } from 'civic-champs-shared/api/hooks/fetchRefactoredSchema'

const useFetchRiders = (): [() => Promise<Person[]>, Status<Person[]>] => {
  const organization = useCurrentOrg()
  const [request, status] = useFetchRefactored<Person[]>({
    errorMessage: 'Error Fetching Riders.  Please refresh the page and try again',
    emptyValue: [],
  })

  const fetchRiders = useCallback(() => {
    return request({
      method: 'get',
      url: `/organizations/${organization.id}/riders`,
    })
  }, [organization.id, request])

  return [fetchRiders, status]
}

export default useFetchRiders
